import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogOverlay,
} from '@/components/ui/dialog';

interface ModalProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  title?: string;
  children: React.ReactNode;
  description?: string;
  style?: string | boolean;
  closeBtn?: React.ReactNode;
  bgBlur?: boolean;
  fullWidth?: boolean;
}

export function Modal({
  open,
  onOpenChange,
  title,
  description,
  children,
  style,
  closeBtn,
  bgBlur = false,
  fullWidth,
}: ModalProps) {
  const hasCustomMaxWidth = typeof style === 'string' && /max-w-/.test(style);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {bgBlur && <DialogOverlay className="bg-transparent backdrop-blur-[5px]" />}
      <DialogContent
        className={`fixed left-1/2 top-1/2 z-50  w-full  ${hasCustomMaxWidth ? '' : 'max-w-[95vw] md:max-w-3xl'} -translate-x-1/2 -translate-y-1/2 overflow-y-auto overflow-x-hidden max-h-[95vh] p-2 md:p-4 ${style ?? ''} [&>button.absolute]:hidden bg-modalBg text-black`}
        onPointerDownOutside={(e) => {
          if ((e.target as HTMLElement)?.closest('[data-confirmation-modal]')) {
            e.preventDefault();
          }
        }}
      >
        {/* HEADER → title left + close button right */}
        {(title || closeBtn) && (
          <DialogHeader className="flex flex-row items-center justify-between gap-2 space-y-0 border-b border-green3 pb-2 text-textcolor">
            <div className="min-w-0">
              <DialogTitle className="break-words text-left text-base font-semibold md:text-xl">
                {title}
              </DialogTitle>
              {description && (
                <DialogDescription className="text-gray-500">{description}</DialogDescription>
              )}
            </div>

            {/* custom close button */}
            {closeBtn && (
              <div onClick={() => onOpenChange?.(false)} className="shrink-0 cursor-pointer">
                {closeBtn}
              </div>
            )}
          </DialogHeader>
        )}

        <div className="overflow-x-auto">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
